import request from "./httpService";



const bookAppointment = (data) => {
    return request({
        method: "POST",
        url: `/appointment/book`,
        data: data,
    });
};

const updateStatus = (data) => {
    return request({
        method: "POST",
        url: `/appointment/status/update`,
        data: data,
    });
};

const get = (param) => {
    return request({
        method: "GET",
        url: '/appointment/byparam',
        params: param
    });
}

const getByDay = (param) => {
    return request({
        method: "GET",
        url: '/appointment/byday',
        params: param
    });
}

const getById = (id) => {
    return request({
        method: "GET",
        url: `/appointment/${id}`,
    });
};

const getByCustomerId = (id, signal, options) => {
    return request({
        method: "GET",
        url: `/appointment/customer/${id}`,
        signal: signal,
        params: options
    });
};

const update = (data) => {
    return request({
        method: "POST",
        url: `/appointment/update`,
        data: data,
    });
};

const deleteAppointment = (id) => {
    return request({
        method: "DELETE",
        url: `/appointment/${id}`,
    });
};

const sendReminder = (id) => {
    return request({
        method: "POST",
        url: `/appointment/reminder/${id}`,
    });
};

export const AppointmentService = {
    bookAppointment,
    get,
    getByDay,
    getById,
    getByCustomerId,
    updateStatus,
    update,
    deleteAppointment,
    sendReminder,
};